import { createApi } from '@reduxjs/toolkit/query/react';
import {
    IAccountManagementDetails,
} from '../../interfaces/account/IAccountChatbox';
import { PaginatedApiResponse } from '../../interfaces/models/models/paginated-response.model';
import { deviceAxiosQuery } from '../../utils/axios/device.axios';
import { IAccountDetails } from '../../interfaces/account/IAccountDetails';

export const chatboxApi = createApi({
    reducerPath: 'chatbox',
    baseQuery: deviceAxiosQuery(),
    tagTypes: ['overall', 'statistics'],
    endpoints: (builder) => ({
		accountManagementDetails: builder.mutation<
            PaginatedApiResponse<IAccountDetails>,
            IAccountManagementDetails
        >({
            query: (data) => ({
                url: `/chatbox/chats/account-management/details?page=${data.pageNumber || 1}&size=${data.pageSize || 10}`,
                method: 'PUT',
                data,
            }),
        }),
        downloadsAccountDetails: builder.mutation<
            { data: { excelLink: string } },
            {
				hotelId: string,
				sourceName?: string
			}
        >({
            query: (data) => ({
                url: `/chatbox/chats/account-management/details-download`,
                method: 'PUT',
                data,
            }),
        }),
    }),
});

export const {
	useAccountManagementDetailsMutation,
    useDownloadsAccountDetailsMutation,
} = chatboxApi;
